import React, { useMemo, useEffect } from 'react'
import lottie, { AnimationConfigWithPath, AnimationConfigWithData, RendererType } from 'lottie-web'
import { uniqueId } from 'lodash'

type LottieLoaderProps<T extends RendererType = 'svg'> = {
	lottieOptions:
		| AnimationConfigWithPath<T>
		| AnimationConfigWithData<T>
		| { path?: string; animationData?: any }
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const LottieLoader: React.FC<LottieLoaderProps> = ({ lottieOptions, ...rest }) => {
	const id = useMemo(() => uniqueId('animation-'), [])

	useEffect(() => {
		const container = document.getElementById(id)

		if (!container) {
			return
		}

		if (container.hasChildNodes()) {
			return
		}

		lottie.loadAnimation({
			...lottieOptions,
			container,
		})
	}, [id, lottieOptions])

	return <div id={id} {...rest} />
}
